import stylesheet from './SuccessStoryCardGroup.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";
import DragScroll from "../../base/util/DragScroll";

class NXTSuccessStoryCardGroup extends CustomComponent {

    dragScroll: DragScroll;

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const scrollContainer = document.createElement('div');
        scrollContainer.classList.add('scroll-container')
        const imageCardContainer = document.createElement('slot');
        imageCardContainer.classList.add('items')
        scrollContainer.appendChild(imageCardContainer);
        this.dragScroll = new DragScroll(imageCardContainer);
        return scrollContainer;
    }

    disconnectedCallback() {
        this.dragScroll?.beforeDestroy();
    }

    connectedCallback() {
        super.connectedCallback();
        this.dragScroll?.mounted();
    }

}

customElements.define('nxt-success-story-card-group', NXTSuccessStoryCardGroup);
